import React, {Fragment, useEffect, useState} from 'react';

import '../../App.css';
import {useNavigate, useParams} from "react-router-dom";
import {Button, Col, Flex, Row, Typography} from "antd";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faPlus} from "@fortawesome/free-solid-svg-icons";
import {useAppDispatch, useAppSelector} from "../../feature/tools";
import {useCookies} from "react-cookie";
import {ItemType} from "rc-collapse/es/interface";
import {Status} from "../../feature/project/status";
import {fetchTags} from "../../feature/project/projectsSlice";
import {Component as ComponentField} from "../../feature/project/setting";
import {Components, groupComponents} from "../common/Components";
import {ComponentDetails} from "../common/ComponentDetails";
import {AddComponentModal} from "../common/AddComponentModal";
import {saveLoreComponent} from "../../feature/project/componentsSlice";
import {fetchLore} from "../../feature/project/loreSlice";
import {ViewMode} from "../common/ViewMode";
import {editorRoles, WithUserPermission} from "../common/WithUserPermission";

const Lore = () => {

    const dispatch = useAppDispatch()
    const {componentId} = useParams();
    const [cookies] = useCookies(['componentView']);
    const {projectId, storyId} = useParams();
    const navigate = useNavigate()
    const story = useAppSelector(state => state.stories.story)
    const lore = useAppSelector(state => state.lores.lore)
    const status = useAppSelector(state => state.lores.status)
    const categories = useAppSelector(state => state.categories.categories)
    const [items, setItems] = useState<ItemType[]>([])
    const [modal, setModal] = useState<number | undefined>(undefined)

    useEffect(() => {
        if ((status === Status.Idle || story?.loreId !== lore?.id) && projectId && story && story.loreId) {
            dispatch(fetchLore({loreId: story.loreId, projectId: parseInt(projectId)}))
            dispatch(fetchTags({projectId: parseInt(projectId)}))
        }
    }, [story, projectId, status, dispatch])


    useEffect(() => {
        const items: ItemType[] = groupComponents(
            lore?.components || [],
            cookies['componentView'] === ViewMode.List,
            `/projects/${projectId}/stories/${storyId}/lore/components/`
        )
        setItems(items)
    }, [cookies['componentView'], lore, dispatch])


    return (
        <Row style={{height: "100%"}}>
            <Col span={componentId ? 16 : 24} style={{height: "100%"}}>
                <Components
                    title={'Lore Components'}
                    categories={categories?.filter((item) => item.type === 'lore' || item.type === 'any') || []}
                    onAddComponentClick={(id: number) => setModal(id)}
                    onBackClick={() => navigate(`/projects/${projectId}/stories/${storyId}`)}
                />
                <div style={{
                    marginTop: 20,
                    marginLeft: '-18px',
                    padding: '0 18px 18px 18px',
                    overflowY: 'auto', scrollbarWidth: "none",
                    overflowX: 'visible',
                    height: 'calc(100% - 60px)',
                    width: 'calc(100% + 36px)'
                }}>
                    {
                        items.map((item: ItemType, index: number) =>
                            <Fragment key={item.key}>
                                <Flex key={item.key} justify={'space-between'} align={'center'}><Typography style={{
                                    fontWeight: 700,
                                    marginTop: index > 0 ? 16 : 0,
                                    marginBottom: 16
                                }}>{item.label}</Typography>
                                    <WithUserPermission roles={editorRoles}>
                                        <Button
                                            type={'text'}
                                            onClick={() => setModal(item.key ? parseInt(item.key?.toString()) : undefined)}>
                                            <FontAwesomeIcon icon={faPlus}/>
                                        </Button>
                                    </WithUserPermission>
                                </Flex>
                                {item.children}
                            </Fragment>
                        )
                    }
                </div>
            </Col>
            {componentId ? <Col span={8} style={{height: "100%"}}>
                <ComponentDetails
                    component={lore?.components?.find((item) => item?.id?.toString() === componentId)}
                    onAddComponent={
                        (component: ComponentField) => {
                            if (lore?.id && projectId) {
                                dispatch(saveLoreComponent({
                                    loreId: lore?.id,
                                    projectId: parseInt(projectId),
                                    component: component
                                }))
                            }
                        }
                    }
                    onClose={() => navigate(`/projects/${projectId}/stories/${storyId}/lore`)}
                />
            </Col> : ''}
            {modal && lore ? <AddComponentModal
                component={{
                    title: '',
                    description: '',
                    tags: [],
                    category: (categories?.find((item) => item.id === modal))
                }}
                visible={true}
                onCancel={() => setModal(undefined)}
                onSave={(component: ComponentField) => {
                    if (modal && projectId) {
                        dispatch(saveLoreComponent({
                            loreId: lore.id,
                            projectId: parseInt(projectId),
                            component: component
                        }))
                    }
                    setModal(undefined)
                }}
            /> : ''}
        </Row>
    );
};

export default Lore;